/* Chloe's Tables — theme.js
   No dependencies. Everything degrades to a working non-JS form post.

   Add to cart lives in ct-cart-bridge.js: this theme uses Horizon's cart icon
   and cart drawer, which refresh off the standard cart event, and that needs a
   module import. */
(function () {
  'use strict';

  /* -------------------------------------------------------- bundle selector */

  document.querySelectorAll('[data-bundle]').forEach(function (bundle) {
    var scope = bundle.closest('[data-product-root]') || document;

    /* The sticky mobile bar is rendered outside the product root, so a scoped
       lookup alone would leave it showing the single price while the card
       above says the pack price. Collect both. */
    function priceNodes(attr) {
      var selector = '[' + attr + ']';
      var nodes = Array.prototype.slice.call(scope.querySelectorAll(selector));
      document.querySelectorAll('[data-sticky-atc] ' + selector).forEach(function (el) {
        if (nodes.indexOf(el) === -1) nodes.push(el);
      });
      return nodes;
    }

    function setPriceRow(data) {
      priceNodes('data-price-current').forEach(function (el) {
        el.textContent = data.price;
        el.classList.toggle('price--sale', !!data.compare);
      });
      priceNodes('data-price-compare').forEach(function (el) {
        el.textContent = data.compare || '';
        el.hidden = !data.compare;
      });
      priceNodes('data-price-save').forEach(function (el) {
        el.textContent = data.save || '';
        el.hidden = !data.save;
      });
    }

    /* The pack name and its free gift ride to checkout as line item properties.
       Both inputs stay disabled while empty: a disabled field is never posted,
       so a pack with no gift adds no stray "Free gift:" line to the order. */
    function setProps(data) {
      [['data-pack-prop', data.pack], ['data-gift-prop', data.gift]].forEach(function (pair) {
        scope.querySelectorAll('[' + pair[0] + ']').forEach(function (input) {
          var value = pair[1] || '';
          input.value = value;
          input.disabled = value === '';
        });
      });
    }

    /* Gifts tray: a tile lights up once the checked pack's quantity reaches
       its unlock level. Without JavaScript nothing here runs and the tiles
       stay in their server-rendered unlocked look, which reads fine. */
    function setGifts(input) {
      var count = parseInt(input.dataset.qty || input.value, 10) || 1;
      scope.querySelectorAll('[data-gift-tile]').forEach(function (tile) {
        tile.classList.toggle('gifts__tile--locked', count < parseInt(tile.dataset.unlockQty, 10));
      });
    }

    bundle.addEventListener('change', function (event) {
      /* Quantity packs: a single-variant product sells packs by quantity, so
         these radios carry a price but no variant of their own. Update the
         displayed total and stop — there is no variant to swap. */
      var qty = event.target.closest('input[name="quantity"]');
      if (qty) {
        setPriceRow(qty.dataset);
        setProps(qty.dataset);
        setGifts(qty);
        return;
      }

      var input = event.target.closest('input[data-variant-id]');
      if (!input) return;

      scope.querySelectorAll('[data-variant-input]').forEach(function (hidden) {
        hidden.value = input.dataset.variantId;
      });

      setPriceRow(input.dataset);
      setProps(input.dataset);
      setGifts(input);

      scope.querySelectorAll('[data-atc]').forEach(function (button) {
        var available = input.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available ? button.dataset.labelAvailable : button.dataset.labelSoldOut;
      });

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', input.dataset.variantId);
        history.replaceState({}, '', url);
      }
    });

    /* Design picker: option 1 is the design, the last option is the pack, so
       every design has its own set of pack radios. Clicking a design shows
       that set and keeps whichever pack the shopper had already chosen. The
       links are real product URLs, so with JavaScript off this whole block
       does nothing and the page simply reloads onto the right design. */
    var picker = scope.querySelector('[data-design-picker]');
    if (picker) {
      picker.addEventListener('click', function (event) {
        var link = event.target.closest('[data-design-link]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey) return;
        event.preventDefault();

        var design = link.dataset.design;
        var wanted = (bundle.querySelector('input:checked') || {}).dataset;
        var wantedKey = wanted && wanted.packKey;

        picker.querySelectorAll('[data-design-link]').forEach(function (el) {
          var on = el === link;
          el.classList.toggle('is-active', on);
          el.setAttribute('aria-pressed', on ? 'true' : 'false');
        });

        var fallback = null;
        var match = null;
        bundle.querySelectorAll('.bundle__option[data-design]').forEach(function (option) {
          var mine = option.dataset.design === design;
          option.hidden = !mine;
          var radio = option.querySelector('input');
          if (!radio) return;
          if (!mine) {
            radio.checked = false;
            return;
          }
          if (!fallback) fallback = radio;
          if (radio.dataset.packKey === wantedKey) match = radio;
        });

        var next = match || fallback;
        if (!next) return;
        next.checked = true;
        /* Reuse the change handler above rather than duplicating the price,
           property, gift-tray and sold-out updates it already does. */
        next.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    /* Line-item-property designs: no variant to swap, so all this does is
       carry the active pill styling for browsers without :has(). */
    var choice = scope.querySelector('[data-design-choice]');
    if (choice) {
      choice.addEventListener('change', function (event) {
        var picked = event.target.closest('.design__option');
        if (!picked) return;
        /* Scope the active styling to this robe's own slot — otherwise picking
           a character for robe 2 would visually clear robe 1. */
        var slot = picked.closest('[data-design-slot]') || choice;
        slot.querySelectorAll('.design__option').forEach(function (el) {
          el.classList.toggle('is-active', el === picked);
        });

        /* Show the robe they just picked. The slide index is authored next to
           the design name, so this stays right if the gallery is reordered. */
        /* Only robe 1 moves the gallery. Picking robe 3's character should
           not yank the photo away from what they just chose for robe 1. */
        var isFirst = !picked.closest('[data-design-slot]') ||
                      picked.closest('[data-design-slot]').dataset.designSlot === '1';
        var slide = isFirst ? event.target.dataset.slide : undefined;
        var gallery = scope.querySelector('[data-gallery]') || document.querySelector('[data-gallery]');
        if (slide !== undefined && gallery) {
          gallery.dispatchEvent(new CustomEvent('mj:goto', { detail: { index: Number(slide) } }));
        }
      });

    }

    /* Per-robe character slots.

       The pack radios only carry a quantity, so the number of character
       pickers on screen has to follow whatever pack is selected. Slots above
       that quantity are hidden AND disabled: hiding alone would still post
       them, which is how a two-pack ends up carrying a third robe's colour. */
    function setDesignSlots(input) {
      var wanted = parseInt(input.dataset.qty || input.value, 10) || 1;
      var fieldset = scope.querySelector('[data-design-choice]');
      if (!fieldset) return;

      fieldset.classList.toggle('design--multi', wanted > 1);

      fieldset.querySelectorAll('[data-design-slot]').forEach(function (slotEl) {
        var n = parseInt(slotEl.dataset.designSlot, 10);
        var on = n <= wanted;
        slotEl.hidden = !on;
        slotEl.querySelectorAll('input[type="radio"]').forEach(function (radio) {
          radio.disabled = !on;
        });
      });
    }

    /* Seed from whichever pack is checked on load, so the properties are right
       for a shopper who never touches the selector. */
    var checked = bundle.querySelector('input:checked');
    if (checked) {
      setProps(checked.dataset);
      setGifts(checked);
      setDesignSlots(checked);
    }

    bundle.addEventListener('change', function (event) {
      var qtyInput = event.target.closest('input[name="quantity"]');
      if (qtyInput) setDesignSlots(qtyInput);
    });
  });

  /* -------------------------------------------------------- looping demo */

  /* Autoplay is set in the markup so the clip starts without waiting on this
     file. All this does is take it back off anyone who has asked their system
     for reduced motion — the poster frame is a perfectly good still. */
  document.querySelectorAll('[data-demo]').forEach(function (video) {
    var quiet = window.matchMedia('(prefers-reduced-motion: reduce)');

    function apply() {
      if (quiet.matches) {
        video.pause();
        video.removeAttribute('autoplay');
      } else {
        video.play().catch(function () { /* a blocked autoplay just leaves the poster up */ });
      }
    }

    apply();
    if (quiet.addEventListener) quiet.addEventListener('change', apply);
  });

  /* -------------------------------------------------------------- gallery */

  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var viewport = gallery.querySelector('[data-gallery-viewport]');
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('.gallery__slide'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-dot]'));
    if (!viewport || slides.length < 2) return;

    function goTo(index) {
      viewport.scrollTo({ left: viewport.clientWidth * index, behavior: 'smooth' });
    }

    function mark(index) {
      thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === index ? 'true' : 'false'); });
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === index ? 'true' : 'false'); });
    }

    thumbs.forEach(function (thumb, i) { thumb.addEventListener('click', function () { goTo(i); }); });
    dots.forEach(function (dot, i) { dot.addEventListener('click', function () { goTo(i); }); });

    gallery.querySelectorAll('[data-gallery-step]').forEach(function (button) {
      button.addEventListener('click', function () {
        var current = Math.round(viewport.scrollLeft / viewport.clientWidth);
        var next = current + Number(button.dataset.galleryStep);
        goTo(Math.max(0, Math.min(slides.length - 1, next)));
      });
    });

    var frame;
    viewport.addEventListener('scroll', function () {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(function () {
        mark(Math.round(viewport.scrollLeft / viewport.clientWidth));
      });
    });

    /* The design picker lives in a different block and needs to drive this
       carousel. A custom event keeps the two decoupled — nothing global. */
    gallery.addEventListener('mj:goto', function (event) {
      var i = Number(event.detail && event.detail.index);
      if (!isNaN(i) && i >= 0 && i < slides.length) goTo(i);
    });

    mark(0);
  });

  /* ----------------------------------------------------------- sticky ATC */

  var sticky = document.querySelector('[data-sticky-atc]');
  var anchor = document.querySelector('[data-atc-anchor]');

  /* Observe the button itself, not the form wrapper.
   *
   * The wrapper spans the bundle picker, the gift tray and the button — on a
   * phone that is well over two screens tall, and the old rule (show only once
   * the wrapper has scrolled entirely past the top) meant the first ~2000px of
   * the page offered no way to buy at all.
   *
   * Keying off the button gives the honest rule: whenever the shopper cannot
   * see a buy button, put one in front of them. That includes page load, where
   * the button starts below the fold. */
  var atcButton = document.querySelector('[data-atc]');
  var watched = atcButton || anchor;

  if (sticky && watched && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        sticky.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0, rootMargin: '-8px 0px -8px 0px' }).observe(watched);

    var jump = sticky.querySelector('[data-sticky-jump]');
    var productForm = document.querySelector('[data-product-form]');

    if (jump) {
      jump.addEventListener('click', function () {
        /* Submit the real form so the cart bridge, the selected pack and the
         * shipping-protection checkbox all behave exactly as they do from the
         * in-page button. Falls back to scrolling if there is no form to
         * submit, or if the browser predates requestSubmit. */
        if (jump.hasAttribute('data-sticky-add') && productForm && productForm.requestSubmit) {
          productForm.requestSubmit();
          return;
        }
        (anchor || watched).scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }

  /* ---------------------------------------------------------- mobile menu */

  var menuToggle = document.querySelector('[data-menu-toggle]');
  var menuPanel = document.querySelector('[data-menu-panel]');
  if (menuToggle && menuPanel) {
    menuToggle.addEventListener('click', function () {
      var open = menuPanel.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* --------------------------------------------------- reviews "load more" */

  document.querySelectorAll('[data-load-more]').forEach(function (button) {
    button.addEventListener('click', function () {
      document.querySelectorAll('[data-review-hidden]').forEach(function (card) {
        card.hidden = false;
        card.removeAttribute('data-review-hidden');
      });
      button.hidden = true;
    });
  });

  /* ------------------------------------------------- dispatch countdown */

  /* Counts down to a real daily cutoff hour. Once today's cutoff passes the
     target rolls to tomorrow, so the number always refers to an actual
     dispatch deadline rather than resetting per visit. Hidden until the first
     tick so it never flashes an empty value. */
  document.querySelectorAll('[data-cutoff]').forEach(function (el) {
    var hour = parseInt(el.dataset.cutoffHour, 10);
    if (isNaN(hour)) return;

    var clock = el.querySelector('[data-cutoff-clock]');
    if (!clock) return;

    function nextCutoff() {
      var now = new Date();
      var target = new Date(now);
      target.setHours(hour, 0, 0, 0);
      if (target <= now) target.setDate(target.getDate() + 1);
      return target;
    }

    var target = nextCutoff();

    function tick() {
      var diff = target - new Date();
      if (diff <= 0) {
        target = nextCutoff();
        diff = target - new Date();
      }
      var totalMinutes = Math.floor(diff / 60000);
      var h = Math.floor(totalMinutes / 60);
      var m = totalMinutes % 60;
      var s = Math.floor(diff / 1000) % 60;
      clock.textContent = h > 0
        ? h + 'h ' + m + 'm'
        : m + 'm ' + (s < 10 ? '0' : '') + s + 's';
      el.hidden = false;
    }

    tick();
    setInterval(tick, 1000);
  });

  /* ------------------------------------------------- sale deadline clock */

  /* Counts down to one fixed end time, set once in theme settings. Unlike the
     dispatch cutoff above there is no rollover: when the deadline passes the
     element removes itself, so a sale can never keep claiming it ends tonight
     the morning after it ended. The worded deadline is already in the markup —
     this only fills in the clock beside it. */
  document.querySelectorAll('[data-deadline]').forEach(function (el) {
    var target = new Date(el.dataset.deadline);
    if (isNaN(target)) return;

    var clock = el.querySelector('[data-deadline-clock]');
    if (!clock) return;

    var timer = setInterval(tick, 1000);

    function tick() {
      var diff = target - new Date();

      if (diff <= 0) {
        clearInterval(timer);
        el.hidden = true;
        return;
      }

      var totalMinutes = Math.floor(diff / 60000);
      var h = Math.floor(totalMinutes / 60);
      var m = totalMinutes % 60;
      var s = Math.floor(diff / 1000) % 60;

      clock.textContent = h > 0
        ? h + 'h ' + (m < 10 ? '0' : '') + m + 'm'
        : m + 'm ' + (s < 10 ? '0' : '') + s + 's';
      clock.hidden = false;
    }

    tick();
  });
})();

/* ============================================================== gallery ++ */
/* Upgrades on top of the scroll-snap carousel, which already handles touch
 * swipe natively. Added here: keyboard arrows, pointer drag on desktop, a
 * live slide counter, and click-to-zoom.
 *
 * Zoom matters more than it looks for apparel — the texture of the pile and
 * the controller detail are exactly what a shopper wants to inspect before
 * spending $100, and on a phone the inline image is too small to judge. */
(function () {
  var galleries = document.querySelectorAll('[data-gallery]');
  if (!galleries.length) return;

  galleries.forEach(function (gallery) {
    var viewport = gallery.querySelector('[data-gallery-viewport]');
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('.gallery__slide'));
    if (!viewport || slides.length < 2) return;

    var index = function () {
      return Math.round(viewport.scrollLeft / viewport.clientWidth);
    };
    var goTo = function (i) {
      viewport.scrollTo({
        left: viewport.clientWidth * Math.max(0, Math.min(slides.length - 1, i)),
        behavior: 'smooth'
      });
    };

    /* ---- keyboard ---- */
    viewport.setAttribute('tabindex', '0');
    viewport.setAttribute('role', 'region');
    viewport.setAttribute('aria-label', 'Product images');
    viewport.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index() - 1); }
    });

    /* ---- counter ---- */
    var counter = document.createElement('span');
    counter.className = 'gallery__counter';
    counter.setAttribute('aria-hidden', 'true');
    counter.textContent = '1 / ' + slides.length;
    (gallery.querySelector('.gallery__stage') || gallery).appendChild(counter);

    var frame;
    viewport.addEventListener('scroll', function () {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(function () {
        counter.textContent = (index() + 1) + ' / ' + slides.length;
      });
    });

    /* ---- pointer drag (desktop only; touch already scrolls natively) ---- */
    var down = false, startX = 0, startScroll = 0, moved = 0;
    viewport.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      down = true; moved = 0;
      startX = e.clientX;
      startScroll = viewport.scrollLeft;
      viewport.classList.add('is-dragging');
    });
    viewport.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      moved = Math.abs(dx);
      viewport.scrollLeft = startScroll - dx;
    });
    var endDrag = function () {
      if (!down) return;
      down = false;
      viewport.classList.remove('is-dragging');
      /* Snap to the nearest slide; free-scrolling leaves it mid-frame. */
      goTo(index());
    };
    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    viewport.addEventListener('pointerleave', endDrag);

    /* ---- zoom ---- */
    slides.forEach(function (slide) {
      var img = slide.querySelector('img');
      if (!img) return;
      slide.style.cursor = 'zoom-in';
      slide.addEventListener('click', function () {
        /* A drag that ends over a slide fires a click too — ignore it. */
        if (moved > 6) { moved = 0; return; }
        openZoom(img.currentSrc || img.src, img.alt);
      });
    });
  });

  /* One dialog reused by every gallery. <dialog> gives the top layer, the
   * backdrop, Esc-to-close and focus trapping without writing any of it. */
  var dialog;
  function openZoom(src, alt) {
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'gallery-zoom';
      dialog.innerHTML =
        '<button class="gallery-zoom__close" aria-label="Close">&times;</button>' +
        '<img class="gallery-zoom__img" alt="">';
      document.body.appendChild(dialog);
      dialog.addEventListener('click', function (e) {
        /* Click the backdrop (the dialog itself) to dismiss. */
        if (e.target === dialog || e.target.closest('.gallery-zoom__close')) dialog.close();
      });
    }
    var img = dialog.querySelector('img');
    img.src = src;
    img.alt = alt || '';
    if (dialog.showModal) dialog.showModal();
  }
})();
